const INTERIORS = [
    {
        src: "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/xvwo3su6_Messenger_creation_CC2B82BC-3FDA-429F-A194-3BA6D33C07F3.webp",
        title: "Cuisine granit noir veiné",
        caption: "Panoramique sur jardin · sur mesure",
        span: "lg:col-span-8",
        aspect: "aspect-[16/11]",
    },
    {
        src: "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/i1ycvfgs_Messenger_creation_89F4E127-FEA6-48A4-BC64-52A25892D8F8.webp",
        title: "Cuisine bois & quartz",
        caption: "Contemporaine · lumière naturelle",
        span: "lg:col-span-4",
        aspect: "aspect-[16/11]",
    },
    {
        src: "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/zorh1egv_Messenger_creation_C86426EA-CC0A-405F-92D0-239EA62DF1C4.webp",
        title: "Salle de bain travertin",
        caption: "Douche à l'italienne · fenêtre haussmannienne",
        span: "lg:col-span-6",
        aspect: "aspect-[4/5]",
    },
    {
        src: "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/8ad8cgpp_Messenger_creation_423FB2F9-DA1C-4857-B386-89598673DAF7.webp",
        title: "Îlot en calacatta viola",
        caption: "Pièce unique · marbre veiné",
        span: "lg:col-span-6",
        aspect: "aspect-[4/5]",
    },
    {
        src: "https://customer-assets-4nw71qhi.emergentagent.net/job_cmrenov-estimator/artifacts/t43qkv4v_Messenger_creation_45F95EC1-EC0E-48AE-9284-74BFE5BD8335.webp",
        title: "Écrin d'exposition · marbre & laiton",
        caption: "Espace commercial premium",
        span: "lg:col-span-12",
        aspect: "aspect-[21/9]",
    },
];

export default function Interiors() {
    return (
        <section
            id="interieurs"
            data-testid="interiors"
            className="py-32 bg-[#F2EEE5] relative overflow-hidden"
        >
            {/* Decorative giant serif letter */}
            <div
                aria-hidden
                className="pointer-events-none absolute -top-20 -left-16 font-serif-lux text-[#B89C6A]/[0.06] text-[36vw] leading-none select-none italic"
            >
                I
            </div>

            <div className="max-w-[1500px] mx-auto px-6 md:px-12 relative">
                {/* Header */}
                <div className="max-w-3xl mb-20 section-fade">
                    <div className="flex items-center gap-3 mb-6">
                        <span className="h-px w-10 bg-[#B89C6A]" />
                        <span className="tracking-luxe text-[#B89C6A]">
                            Intérieurs livrés · Portfolio
                        </span>
                    </div>
                    <h2 className="font-serif-lux text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
                        L'aboutissement du{" "}
                        <em className="italic text-[#B89C6A]">geste</em>.
                    </h2>
                    <p className="mt-6 text-[15px] leading-relaxed text-[#1C1E1D]/70 max-w-xl">
                        Marbres calacatta viola, travertin cannelé, parquets massifs,
                        menuiseries sur mesure : chaque intérieur CM RENOV est une
                        composition unique, à la croisée du patrimoine et du geste
                        contemporain.
                    </p>
                </div>

                {/* Asymmetric bento grid */}
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6 auto-rows-auto">
                    {INTERIORS.map((it, i) => (
                        <figure
                            key={i}
                            data-testid={`interior-${i}`}
                            className={`group relative overflow-hidden bg-[#0e0f0e] section-fade ${it.span}`}
                        >
                            <div className={`${it.aspect} overflow-hidden`}>
                                <img
                                    src={it.src}
                                    alt={it.title}
                                    loading="lazy"
                                    className="w-full h-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.19,1,0.22,1)] group-hover:scale-[1.05]"
                                />
                            </div>

                            {/* Overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-[#0e0f0e]/85 via-[#0e0f0e]/10 to-transparent opacity-70 group-hover:opacity-95 transition-opacity duration-500" />

                            {/* Caption */}
                            <figcaption className="absolute inset-x-0 bottom-0 p-6 md:p-8 text-[#FAF9F6]">
                                <div className="tracking-luxe text-[#B89C6A] mb-2">
                                    {String(i + 1).padStart(2, "0")} · {it.caption}
                                </div>
                                <div className="font-serif-lux text-2xl md:text-3xl leading-tight max-w-lg">
                                    {it.title}
                                </div>
                                <div className="mt-4 h-px w-0 group-hover:w-16 bg-[#B89C6A] transition-all duration-700" />
                            </figcaption>
                        </figure>
                    ))}
                </div>

                {/* Closing */}
                <div className="mt-20 text-center section-fade">
                    <div className="tracking-luxe text-[#B89C6A] mb-4">
                        Votre intérieur, notre prochain chapitre
                    </div>
                    <a
                        href="#rendezvous"
                        data-testid="interiors-cta"
                        className="btn-outline inline-flex"
                    >
                        Prendre rendez-vous
                    </a>
                </div>
            </div>
        </section>
    );
}
